import React from 'react'
import { Button, Nav } from 'react-bootstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import { signOut } from 'aws-amplify/auth'
import CharityManager from '../../../components/CharityManager'

function AdminCharities() {
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut()
    navigate('/admin')
  }

  return (
    <section className="py-4">
      <header className="mb-4 d-flex justify-content-between align-items-center">
        <div>
          <p
            className="text-uppercase fw-semibold text-muted mb-1"
            style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}
          >
            Admin
          </p>
          <h2 className="fw-bold mb-0">Charity Manager</h2>
        </div>
        <Button variant="outline-secondary" size="sm" onClick={handleSignOut}>
          Sign Out
        </Button>
      </header>
      <hr className="opacity-25" />
      <Nav variant="tabs" className="mb-4">
        <Nav.Item>
          <Nav.Link as={NavLink} to="/admin/charities">
            Charity Manager
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={NavLink} to="/admin/sre">
            SRE Events
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={NavLink} to="/admin/stock">
            Stock Pricing
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={NavLink} to="/admin/snp500">
            S&amp;P 500 List
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={NavLink} to="/admin/investments">
            Investments
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <CharityManager />
    </section>
  )
}

export default AdminCharities
